import React, { useState, useEffect } from 'react';
import { getAutoReply } from '../common/whatsapp';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
  TablePagination,
  Button,
  IconButton,
  Switch,
  Dialog,
} from '@material-ui/core';
import { Edit, Delete } from '@material-ui/icons';
import CreateAutoreply from './Autoreply/CreateAutoreply'; // Import the CreateAutoreply component
import InfoBox from '../../components/InfoIcon/InfoIcon';

const Autoreply = (props) => {
  const { admin, username } = props.user;
  const {phoneSelections} = props;
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [openDialog, setOpenDialog] = useState(false);
  const [selectedAutoreply, setSelectedAutoreply] = useState(null);

  // Fetch autoreply data
  useEffect(() => {
    const fetchData = async () => {
      if (!admin) return;

      setLoading(true);
      try {
        const responseList = await getAutoReply({ admin, username });
        setList(responseList);
      } catch (err) {
        setError('Failed to fetch autoreply records. Please try again later.');
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [admin, username]);

  // Handle pagination
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  // Handle edit
  const handleEdit = (autoreply) => {
    setSelectedAutoreply(autoreply);
    setOpenDialog(true);
  };

  // Handle delete
  const handleDelete = async (id) => {
    try {
      // Call API to delete autoreply
      // await deleteAutoReply(id);
      const updatedList = list.filter((item) => item._id !== id);
      setList(updatedList);
    } catch (err) {
      setError('Failed to delete autoreply.');
    }
  };

  // Handle status change
  const handleStatusChange = async (id, newStatus) => {
    try {
      // Call API to update autoreply status
      // await updateAutoReplyStatus(id, newStatus);
      const updatedList = list.map((item) =>
        item._id === id ? { ...item, status: newStatus } : item
      );
      setList(updatedList);
    } catch (err) {
      setError('Failed to update autoreply status.');
    }
  };

  // Handle dialog close
  const handleDialogClose = () => {
    setOpenDialog(false);
    setSelectedAutoreply(null);
  };

  // Handle dialog submit
  const handleDialogSubmit = (data) => {
    if (selectedAutoreply) {
      // Update existing autoreply
      const updatedList = list.map((item) =>
        item._id === selectedAutoreply._id ? { ...item, ...data } : item
      );
      setList(updatedList);
    } else {
      // Add new autoreply
      setList([...list, { ...data, _id: Date.now().toString() }]);
    }
    handleDialogClose();
  };

  return (
    <div>
      <br />
        <span style={{float:"right"}}>
            <InfoBox name={'Whatsapp.connect'} />
        </span>
      <Typography variant="h4" gutterBottom>
        Autoreply
      </Typography>

      <Typography variant="body1" gutterBottom>
        Configure automatic replies for your WhatsApp accounts.
      </Typography>

      <Button
        variant="contained"
        color="primary"
        onClick={() => {
          setSelectedAutoreply(null);
          setOpenDialog(true);
        }}
      >
        Create Autoreply
      </Button>

      {error ? (
        <Typography variant="body2" color="error">
          {error}
        </Typography>
      ) : loading ? (
        <Typography variant="body2" color="textSecondary">
          Loading...
        </Typography>
      ) : list.length > 0 ? (
        <>
          <TableContainer component={Paper}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Phone ID</TableCell>
                  <TableCell>Keyword</TableCell>
                  <TableCell>Reply Message</TableCell>
                  <TableCell>Campaign</TableCell>
                  <TableCell>Type</TableCell>
                  <TableCell>Actions</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {list
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((item) => (
                    <TableRow key={item._id}>
                      <TableCell>{item.name}<br/>{item.phoneNumberId}</TableCell>
                      <TableCell>{item.keyword}</TableCell>
                      <TableCell>{(item.replyData && item.replyData.text) ? item.replyData.text  : item.replyData.template  }</TableCell>
                     
                        <TableCell>{item.campaignName}</TableCell>
                        <TableCell>
                      {item.replyType}
                      </TableCell>
                      <TableCell>
                        {
                        
                        <IconButton onClick={() => handleEdit(item)}>
                          <Edit />
                        </IconButton>
                          
                        }

                        

                      </TableCell>
                    </TableRow>
                  ))}
              </TableBody>
            </Table>
          </TableContainer>
          <TablePagination
            rowsPerPageOptions={[5, 10, 25]}
            component="div"
            count={list.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </>
      ) : (
        <Typography variant="body2" color="textSecondary">
          No autoreply records found.
        </Typography>
      )}

      {/* Dialog for Create/Edit Autoreply */}
      <Dialog
        open={openDialog}
        onClose={handleDialogClose}
        maxWidth="md"
        fullWidth
      >
        <CreateAutoreply
          user={props.user}
          phoneSelections={phoneSelections}
          initialData={selectedAutoreply}
          onSubmit={handleDialogSubmit}
          onCancel={handleDialogClose}
        />
      </Dialog>
    </div>
  );
};

export default Autoreply;